import React, { createContext, useContext, useEffect, useState } from 'react';
import { loadSettings, saveSettings } from '../store/settings';
import audioManager from '../audio/audioManager';

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(() => loadSettings());

  // Keep the audio engine in sync with preferences.
  useEffect(() => {
    audioManager.setSoundEnabled(settings.soundEnabled);
    saveSettings(settings);
  }, [settings]);

  const update = (patch) => setSettings((s) => ({ ...s, ...patch }));

  return (
    <SettingsContext.Provider value={{ settings, update }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  const ctx = useContext(SettingsContext);
  if (!ctx) throw new Error('useSettings must be used within SettingsProvider');
  return ctx;
}
